<mat-form-field class="full-width-field">
    <mat-label>{{placeholderLabel}}</mat-label>
    <input [disabled]="disabled" matInput [matDatepicker]="datepicker" [formControl]="selectCtrl" [ngModel]="defaultID"
        [placeholder]="placeholder" autocomplete="off" (focus)="datepicker.open()">
    <mat-datepicker-toggle matSuffix [for]="datepicker">
    </mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>
</mat-form-field>